import UserService from '@/services/userService'
import {apiToUser} from './converters'

const userService = UserService(apiToUser)

export default {
  ...userService,
}



// WEBPACK FOOTER //
// ./src/-client-app/services/userService.js